import { render, staticRenderFns } from "./ReportsEditPortal.vue?vue&type=template&id=61465f7f"
import script from "./ReportsEditPortal.vue?vue&type=script&lang=js"
export * from "./ReportsEditPortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports